import React from 'react';
import { useAppState } from '../hooks/useAppState';
import { TicketStatus } from '../types/api';
import { formatDate } from '../utils/validation';
import BackButton from '../components/BackButton';
import CouponCard from '../components/CouponCard';
import CalculatorCard from '../components/CalculatorCard';
import { getConfig } from '../services/configManager';
const TicketSummaryPage: React.FC = () => {
  const { state, setStep, setSelectedFlow, canProceedToPayment, getTicketStatusMessage } = useAppState();
  const { currentTicket } = state;
  const config = getConfig();

  const memberEnabled = config.FEATURES.Member.Enabled;
  const guestEnabled = config.FEATURES.Guest.Enabled;

  if (!currentTicket) {
    return <div>No ticket found</div>;
  }

  const handleFlowSelection = (flow: 'member' | 'guest') => {
    setSelectedFlow(flow);
    setStep(flow === 'member' ? 'member-registration' : 'guest-registration');
  };

  const handleBackToHome = () => {
    setStep('home');
  };

  return (
    <div className="flex-1 flex flex-col p-5">
      <div className="mb-4">
        <BackButton />
      </div>
      <div className="flex-1 flex items-center justify-center">
        <div className="container-card w-full max-w-sm">
        <h1 className="text-title font-extrabold text-black text-center mb-8">
          Ticket Summary
        </h1>
        
        <div className="flex flex-col gap-4 mb-8">
          <div className="flex justify-between">
            <span className="text-black text-md">Ticket:</span>
            <span className="text-black text-md font-semibold">
              {currentTicket.ticketNumber || 'N/A'}
            </span>
          </div>
          
          <div className="flex justify-between">
            <span className="text-black text-md">Parking Lot:</span>
            <span className="text-black text-md font-semibold">
              {currentTicket.spot?.name || 'N/A'}
            </span>
          </div>
          
          <div className="flex justify-between">
            <span className="text-black text-md">Car Plate:</span>
            <span className="text-black text-md font-semibold">
              {currentTicket.vehicleNumber || 'N/A'}
            </span>
          </div>
          
          <div className="flex justify-between">
            <span className="text-black text-md">Entry:</span>
            <span className="text-black text-md font-semibold">
              {formatDate(currentTicket.entryDate)}
            </span>
          </div>
          
          {currentTicket.exitDate && (
            <div className="flex justify-between">
              <span className="text-black text-md">Exit:</span>
              <span className="text-black text-md font-semibold">
                {formatDate(currentTicket.exitDate)}
              </span>
            </div>
          )}
          
          <div className="flex justify-between">
            <span className="text-black text-md">Status:</span>
            <span className={`text-md font-semibold ${
              currentTicket.status === TicketStatus.active ? 'text-green-600' :
              currentTicket.status === TicketStatus.paid ? 'text-blue-600' :
              currentTicket.status === TicketStatus.voided ? 'text-orange-600' :
              'text-red-600'
            }`}>
              {currentTicket.status.toUpperCase()}
            </span>
          </div>
        </div>
        
        <div className="text-center text-black text-md mb-6">
          {getTicketStatusMessage(currentTicket.status)}
        </div>
        
        {canProceedToPayment(currentTicket.status) ? (
          <div className="flex flex-col gap-4">
            <CouponCard />

            {memberEnabled && (<button
              onClick={() => handleFlowSelection('member')}
              className="btn-primary w-full"
            >
              Join as a Member
            </button>)}
            {guestEnabled && (<button
              onClick={() => handleFlowSelection('guest')}
              className="w-full px-6 py-3 text-md font-semibold text-black bg-white border-2 border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200"
            >
              Continue as Guest
            </button>)}

            <div className="p-4 bg-gray-50 rounded-lg">
              {memberEnabled && guestEnabled && (
              <p className="text-sm text-gray-700 mb-3">
                Before we continue, please choose how you'd like to proceed:
              </p> )}
              <div className="space-y-2 text-sm text-gray-600">
              {memberEnabled &&  (<p>
                  <span className="font-semibold text-black">Join as a Member</span> - Create an account for faster exits, receipts by email, and easy access to your parking history.
                </p> )}
                {guestEnabled &&  (
                <p>
                  <span className="font-semibold text-black">Continue as Guest</span> - Skip registration and just pay at the end of your visit.
                </p>)}
              </div>
            </div>

            <CalculatorCard />
            
            <button
              onClick={handleBackToHome}
              className="btn-primary w-full"
            >
              Back to Home
            </button>
          </div>
        ) : (
          <div className="flex flex-col gap-4">
            {currentTicket.status === TicketStatus.voided && (
              <>
                <CouponCard />
                <CalculatorCard />
              </>
            )}
            <button
              onClick={handleBackToHome}
              className="btn-primary w-full"
            >
              Back to Home
            </button>
          </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default TicketSummaryPage; 